import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { globalSearchAddress } from "@pages/AdminDashboard/adminRoutes";
import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { SearchInput } from "@pages/AdminDashboard/ui/SearchInput";

const { color, typeScale } = adminTokens;
const [, , spaceMd, , , , spaceXl] = adminTokens.spacing;
// The design's top bar: 64px tall, the search at most 460px wide.
const topBarHeight = 64;
const searchWidth = 460;

const TopBar = styled.header`
  display: flex;
  flex: none;
  align-items: center;
  gap: ${spaceMd}px;
  box-sizing: border-box;
  height: ${topBarHeight}px;
  padding: 0 ${spaceXl}px;
  background-color: ${color.surface};
  border-bottom: 1px solid ${color.border};
`;

const SearchSlot = styled.div`
  width: ${searchWidth}px;
  max-width: 100%;
`;

const RoutesNote = styled.span`
  color: ${color.inkSoft};
  font-family: ${typeScale.body.fontFamily};
  font-size: 12px;
`;

// The search every screen carries: an email opens User Search and anything else
// opens Order Search (SHELL-R15…R20, XCUT-R6).
export const AdminTopBar = () => {
  const history = useHistory();

  const search = (entry: string) => {
    const address = globalSearchAddress(entry);
    if (address) history.push(address);
  };

  return (
    <TopBar>
      <SearchSlot>
        <SearchInput
          label="Search for a User or an Order"
          placeholder="Find a User by email, or an Order by Order ID or Case ID"
          hasEnterHint
          onSearch={search}
        />
      </SearchSlot>
      <RoutesNote>Routes to Find</RoutesNote>
    </TopBar>
  );
};
